var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 728 563.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363436;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.3,347.31S59,13.42,296,21.42c86.91,2.93,146.37-5.82,186.83-18.08,69.07-20.92,123.35,61.05,76.25,115.73-32.68,37.94-99.44,66.29-228,62.81a169.43,169.43,0,0,1-19.88-1.71C281.47,175.83,160.42,170.22,84.3,347.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.62,132.42s128.85,70,103.72,202.23a19.07,19.07,0,0,1-18.76,15.47H608.84s5.62-115.06-100.61-194.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.3,347.31l28.23.39s21.63-96.7,73.05-135L120,207.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.94,107.33s63.22,53.79,73.64,133.94-73.64-67-73.64-67l-42-41.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "485.04 164.73 478 204.42 534.79 178.41 542 141.42 497.88 141.42 485.04 164.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.3,347.31S116.07,543.51,82.54,564c0,0,74.52-9,30-216.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.19,343S606.42,539.23,640,559.69c0,0-74.53-9-30-216.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 100.5,
    cy: 121.4,
    rx: 100.5,
    ry: 91.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 627.5,
    cy: 130.4,
    rx: 100.5,
    ry: 91.98
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset12);
export default __webpack_public_path__ + "static/media/Asset 12.bdeb4d63.svg";
export { ForwardRef as ReactComponent };